/* tslint:disable */

/**
 */
export class UploadFile {
    company_id?: number;
    data?: string;
}
